"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-ExportNotification',
    section: 'c-ExportNotificaion__section',
    title: 'c-ExportNotification__title',
    content: 'c-ExportNotification__content',
    modal: 'c-ExportNotification__modal'
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        color: theme_1.DefaultTheme.font.color.primary
    },
    _a[exports.CSS.section] = {
        'padding-bottom': theme_1.DefaultTheme.space(1)
    },
    _a[exports.CSS.title] = {
        'font-weight': theme_1.DefaultTheme.font.weight.bold
    },
    _a[exports.CSS.content] = {
        'list-style': 'none',
        margin: 0
    },
    _a[exports.CSS.modal] = {
        'min-width': '650px'
    },
    _a);
//# sourceMappingURL=export.notification.style.js.map